import React, { useMemo } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { NAV_CATEGORIES, serviceFormHref } from '../mock';
import { useLanguage } from '../i18n/LanguageContext';
import { serviceTitle, serviceDesc } from '../i18n/serviceCopy';
import QuickProcessSteps from '../components/QuickProcessSteps';
import { CoreServicesGrid } from '../components/Sections';

const AllServices = () => {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const catParam = (searchParams.get('cat') || '').trim().toUpperCase();
  const focusedCategoryRow = NAV_CATEGORIES.find((c) => c.category === catParam);

  const active = useMemo(
    () => (focusedCategoryRow ? NAV_CATEGORIES.find((cat) => cat.category === focusedCategoryRow.category) : null),
    [focusedCategoryRow],
  );

  // No ?cat= yet: show the category picker so people choose what to browse.
  if (!active) {
    return (
      <div className="pt-20 min-h-screen">
        <CoreServicesGrid />
      </div>
    );
  }

  return (
    <div className="pt-24 pb-20 hero-gradient min-h-screen">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-6">
          <div className="mb-4">
            <Link
              to="/all-services"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-[#14A098] hover:text-[#0e7a74] underline-offset-2 hover:underline"
            >
              <ArrowLeft className="w-4 h-4 shrink-0" aria-hidden />
              {t('sf.browse_all_categories', 'Browse all categories')}
            </Link>
          </div>
          <QuickProcessSteps className="mb-3" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {active.services.map((svc) => {
            return (
              <Link key={svc.code} to={serviceFormHref(svc.code)} className="card-lift group p-5 rounded-2xl border border-gray-100 bg-white">
                <h3 className="font-bold text-[#0f2540] mb-1 leading-snug">{serviceTitle(svc.code, t, svc.title)}</h3>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">{serviceDesc(svc.code, t, svc.desc)}</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 rounded-full border border-[#14A098] bg-[#14A098] px-3 py-1.5 text-[11px] sm:text-xs font-semibold text-white shadow-sm whitespace-normal text-center leading-snug">
                    {t('common.get_my_service_done', 'Get my {service} done', { service: serviceTitle(svc.code, t, svc.title) })}{' '}
                    <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default AllServices;
